<template>
    <div class="iframe-container">
        <iframe ref="iframe" :src="baseURL" :width="widowWidth+'px'" :height="windowHeight+'px'"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            baseURL: process.env.VUE_APP_WEB_URI,
            targetURL: '',
            iframe: null,
            setLocalStorage: false,
            widowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        }
    },
    created() {
        const id = this.$route.query.id
        this.targetURL = `${this.baseURL}query-result?id=${id}&control=0`
    },
    mounted() {
        const iframe = this.$refs.iframe
        iframe.addEventListener('load', this.onIframeLoaded);

    },
    methods: {
        onIframeLoaded() {
            // 检查是否可以访问 iframe 的内容
            try {
                // 向 iframe 的 localStorage 添加数据
                const userInfo = this.$store.getters['user/getUser']
                userInfo.system = 8
                console.log('Iframe has loaded');
                const iframeWindow = this.$refs.iframe.contentWindow;
                // 在此处添加更多的操作
                iframeWindow.postMessage(
                    {
                        userInfo
                    },
                    this.baseURL,
                )
                if (!this.setLocalStorage) { 
                    this.setLocalStorage = true
                    this.$refs.iframe.src = this.targetURL;
                }

            } catch (error) {
                console.error('无法访问 iframe 的 thirdLoginInfo:', error);
            }

        }
    },
}
</script>
<style scoped lang='scss'>
.iframe-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

#myIframe {
    flex: 1;
    width: 100%;
    height: 100%;
}
</style>